import "./styles.scss";

import edit from "./edit";

import { __ } from "@wordpress/i18n";
import { InnerBlocks } from "@wordpress/block-editor";
import { registerBlockType } from "@wordpress/blocks";
import icons from "~buildable/utils/icons";

export const name = "buildable/meet-the-team";

export const settings = {
  title: "Meet the Team",
  icon: icons["meet-the-team"],
  category: "buildable-groups",
  supports: {
    align: ['full']
  },
  /** @var MeetTheTeam_Attributes object */
  attributes: MeetTheTeam_Attributes,
  description: __("The Meet the Team block is best used for displaying an image-based staff directory in a card format. A bio can be assigned for each staff member card, and will appear when hovering over or clicking on the object."),
  edit,
  save: () => <InnerBlocks.Content />
}

registerBlockType(name, settings);
